import { render, staticRenderFns } from "./PersonPwd.vue?vue&type=template&id=5209c5b6&scoped=true&"
import script from "./PersonPwd.vue?vue&type=script&lang=js&"
export * from "./PersonPwd.vue?vue&type=script&lang=js&"
import style0 from "./PersonPwd.vue?vue&type=style&index=0&id=5209c5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209c5b6",
  null
  
)

export default component.exports